import { gql } from '@apollo/client';
export const GetProductCount = gql`
	query GetProductCount($categoryIds: [String!]!) {
		getProductCountForCategory(categoryIds: $categoryIds) {
			id
			name
			count
			children {
				id
				name
				count
				children {
					id
					name
					count
				}
			}
		}
	}
`;
